export default "__VITE_ASSET__D6Q4w8_9__";